import React, {useState, useTransition} from 'react'
import Axios from 'axios'
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import {useTranslation} from "react-i18next";
import Dropdown from '../Assets/Components/Dropdown.js';

import '../Assets/scss/form.scss';

import previous from '../Assets/Images/arrow-left.png'
import logo from '../Assets/Images/logo.png'
import enFlag from '../Assets/Images/enFlag.svg'
import duFlag from '../Assets/Images/duFlag.svg'
import frFlag from '../Assets/Images/frFlag.svg'
import esFlag from '../Assets/Images/esFlag.svg'
import itFlag from '../Assets/Images/itFlag.svg'
import ptFlag from '../Assets/Images/ptFlag.svg'
import nlFlag from '../Assets/Images/nlFlag.svg'
import tkFlag from '../Assets/Images/tkFlag.svg'
import ruFlag from '../Assets/Images/ruFlag.svg'
import roFlag from '../Assets/Images/roFlag.svg'
import zhFlag from '../Assets/Images/zhFlag.svg'
import koFlag from '../Assets/Images/koFlag.svg'

export default function Form() {
    
    // manage request
    const url = "https://svr.noracle.io/forms/airdrop"
    const [data, setData] = useState({
        TW : "",
        TG : "",
        DC : "",
        MD : "",
        FB : "",
        YT : "",
        TK : ""
    })
    
    // Manage languages & dropdown
    const [t, i18n] = useTranslation("global");
    const [open, setOpen] = React.useState(false);
    const [ln, setLn] = useState(<button><img src={enFlag} alt='EN'/><span>{t("lang.en")}</span><strong>EN</strong></button>)

    
    const handleChangeLang = (lang, e) => {
        i18n.changeLanguage(lang)

        setOpen(false);
        if (lang === "en"){
            setLn(<button onClick={(e) => handleChangeLang("en")}>
            <img src={enFlag} alt='EN'/>
            <span>{t("lang.en")}</span>
            <strong>EN</strong>
        </button>)
        }else if (lang === "du"){
            setLn(<button onClick={(e) => handleChangeLang("du", e)}>
            <img src={duFlag} alt='DU'/>
            <span>{t("lang.du")}</span>
            <strong>DE</strong>
        </button>)
        }else if (lang === "fr"){
            setLn(<button onClick={(e) => handleChangeLang("fr", e)}>
            <img src={frFlag} alt='FR'/>
            <span>{t("lang.fr")}</span>
            <strong>FR</strong>
        </button>)
        }else if (lang === "es"){
            setLn(<button onClick={(e) => handleChangeLang("es", e)}>
            <img src={esFlag} alt='ES'/>
            <span>{t("lang.es")}</span>
            <strong>ES</strong>
        </button>)
        }else if (lang === "it"){
            setLn(<button onClick={(e) => handleChangeLang("it", e)}>
            <img src={itFlag} alt='IT'/>
            <span>{t("lang.it")}</span>
            <strong>IT</strong>
        </button>)
        }else if (lang === "pt"){
            setLn(<button onClick={(e) => handleChangeLang("pt", e)}>
            <img src={ptFlag} alt='PT'/>
            <span>{t("lang.pt")}</span>
            <strong>PT</strong>
        </button>)
        }else if (lang === "nl"){
            setLn(<button onClick={(e) => handleChangeLang("nl", e)}>
            <img src={nlFlag} alt='NL'/>
            <span>{t("lang.nl")}</span>
            <strong>NL</strong>
        </button>)
        }else if (lang === "tk"){
            setLn(<button onClick={(e) => handleChangeLang("tk", e)}>
            <img src={tkFlag} alt='TK'/>
            <span>{t("lang.tk")}</span>
            <strong>TK</strong>
        </button>)
        }else if (lang === "ru"){
            setLn(<button onClick={(e) => handleChangeLang("ru", e)}>
            <img src={ruFlag} alt='RU'/>
            <span>{t("lang.ru")}</span>
            
            <strong>RU</strong>
        </button>)
        }else if (lang === "ro"){
            setLn(<button onClick={(e) => handleChangeLang("ro", e)}>
            <img src={roFlag} alt='RO'/>
            <span>{t("lang.ro")}</span>
            
            <strong>RO</strong>
        </button>)
        }else if (lang === "zh"){
            setLn(<button onClick={(e) => handleChangeLang("zh", e)}>
            <img src={zhFlag} alt='ZH'/>
            <span>{t("lang.zh")}</span>
            
            <strong>ZH</strong>
        </button>)
        }else if (lang === "ko"){
            setLn(<button onClick={(e) => handleChangeLang("ko", e)}>
            <img src={koFlag} alt='KO'/>
            <span>{t("lang.ko")}</span>
            <strong>KO</strong>
        </button>)
        }
    };

    // Manage action after submit 
    function submit(e){
        
        
        const newData = {...data};
        if((newData["TW"] + newData["TG"] + newData["DC"] +  newData["MD"] + newData["FB"] + newData["YT"] + newData["DC"]).trim() == ""){
            confirmAlert({
                title: t("alert.oneOrMore.title"),
                message: t("alert.oneOrMore.message"),
                buttons: [
                    {
                        label: t("alert.oneOrMore.confirm"),
                    }
                ],
                closeOnClickOutside: true,
            });
        }else {
            e.preventDefault()
        
            Axios.post(url, {
                TW : data.TW,
                TG : data.TG,
                DC : data.DC,
                MD : data.MD,
                FB : data.FB,
                YT : data.YT,
                TK : data.TK
            })
            .then(() => {
                confirmAlert({
                  title: t("alert.success.title"),
                  message: t("alert.success.message"),
                  buttons: [
                    {
                        label: t("alert.success.confirm"),
                  }
                  ],
                  closeOnClickOutside: true,
              });
               newData["TW"] = "";
               newData["TG"] = "";
               newData["DC"] = "";
               newData["MD"] = "";
               newData["FB"] = "";
               newData["YT"] = "";
               newData["TK"] = "";
               setData(newData)
            })
            .catch(function (error) {
                if (error.response !== undefined && error.response.status == 500) {
                    confirmAlert({
                        title: t("alert.idError.title"),
                        message: t("alert.idError.message"),
                        buttons: [
                          {
                              label: t("alert.idError.confirm"),
                        }
                        ],
                        closeOnClickOutside: true,
                });
                }else{
                    confirmAlert({
                        title: t("alert.error.title"),
                        message: t("alert.error.message"),
                        buttons: [
                          {
                              label: t("alert.error.confirm"),
                        }
                        ],
                        closeOnClickOutside: true,
                    });
                }

            })
        }
        
    }

    //manage input when typuing
    function handleChange(e){
        const newData = {...data}
        newData[e.target.id] = e.target.value 
        setData(newData)
    }
    function handleClear(e){
        const newData = {...data}
        newData[e] = ""
        setData(newData)
    }

    return (
        <div className='form'>
            <a className='back' href='https://www.noracle.io/'>
                <img src={previous} alt='<<'/>
                {t("button.back")}
            </a>
            <div>
                <Dropdown
                    trigger={ln}
                    menu={[
                        <button onClick={(e) => handleChangeLang("en")}>
                            <img src={enFlag} alt='EN'/>
                            <span>{t("lang.en")}</span>
                            <strong>EN</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("du", e)}>
                            <img src={duFlag} alt='DU'/>
                            <span>{t("lang.du")}</span>
                            <strong>DE</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("fr", e)}>
                            <img src={frFlag} alt='FR'/>
                            <span>{t("lang.fr")}</span>
                            <strong>FR</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("es", e)}>
                            <img src={esFlag} alt='ES'/>
                            <span>{t("lang.es")}</span>
                            <strong>ES</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("it", e)}>
                            <img src={itFlag} alt='IT'/>
                            <span>{t("lang.it")}</span>
                            <strong>IT</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("pt", e)}>
                            <img src={ptFlag} alt='PT'/>
                            <span>{t("lang.pt")}</span>
                            <strong>PT</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("nl", e)}>
                            <img src={nlFlag} alt='NL'/>
                            <span>{t("lang.nl")}</span>
                            <strong>NL</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("tk", e)}>
                            <img src={tkFlag} alt='TK'/>
                            <span>{t("lang.tk")}</span>
                            <strong>TK</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("ru", e)}>
                            <img src={ruFlag} alt='RU'/>
                            <span>{t("lang.ru")}</span>
                            
                            <strong>RU</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("ro", e)}>
                            <img src={roFlag} alt='RO'/>
                            <span>{t("lang.ro")}</span>
                            
                            <strong>RO</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("zh", e)}>
                            <img src={zhFlag} alt='ZH'/>
                            <span>{t("lang.zh")}</span>
                            
                            <strong>ZH</strong>
                        </button>,
                        <button onClick={(e) => handleChangeLang("ko", e)}>
                            <img src={koFlag} alt='KO'/>
                            <span>{t("lang.ko")}</span>
                            <strong>KO</strong>
                        </button>
                    ]}
                />
            </div>
            <img src={logo} alt='LOGO'/>
            {/*
            <div className='instruction'>{t("content.howToDo")}</div>
            <form>
                <div>
                    <input type="checkbox" className='twitterCheck' onClick={() => handleClear("TW")}/>
                    <input type="text" id='TW' className='twitter' value={data.TW} onChange={(e) => handleChange(e)} required/>
                    <label for="TW">{t("id.tw")}</label>
                    <div className="underlined"></div>
                </div>
                <div>
                    <input type="checkbox" className='telegramCheck' onClick={() => handleClear("TG")}/>
                    <input type="text" id='TG' className='telegram' value={data.TG} onChange={(e) => handleChange(e)} required/>
                    <label for="TG">{t("id.tg")}</label>
                    <div className="underlined"></div>
                </div>
                <div>
                    <input type="checkbox" className='discordCheck' onClick={ () => handleClear("DC")}/>
                    <input type="text" id='DC' className='discord' value={data.DC} onChange={(e) => handleChange(e)} required/>
                    <label for="DC">{t("id.dc")}</label>
                    <div className="underlined"></div>
                </div>
                <div>
                    <input type="checkbox" className='mediumCheck' onClick={ () => handleClear("MD")}/>
                    <input type="text" id='MD' className='medium' value={data.MD} onChange={(e) => handleChange(e)} required/>
                    <label for="MD">{t("id.md")}</label>
                    <div className="underlined"></div>
                </div>
                <div>
                    <input type="checkbox" className='facebookCheck' onClick={ () => handleClear("FB")}/>
                    <input type="text" id='FB' className='facebook' value={data.FB} onChange={(e) => handleChange(e)} required/>
                    <label for="FB">{t("id.fb")}</label>
                    <div className="underlined"></div>
                </div>
                <div>
                    <input type="checkbox" className='youtubeCheck' onClick={ () => handleClear("YT")}/>
                    <input type="text" id='YT' className='youtube' value={data.YT} onChange={(e) => handleChange(e)} required/>
                    <label for="YT">{t("id.yt")}</label>
                    <div className="underlined"></div>
                </div>
                <div>
                    <input type="checkbox" className='tiktokCheck' onClick={ () => handleClear("TK")}/>
                    <input type="text" id='TK' className='tiktok' value={data.TK} onChange={(e) => handleChange(e)} required/>
                    <label for="TK">{t("id.tk")}</label>
                    <div className="underlined"></div>
                </div>
            </form>
            <div className='notice'>{t("content.remember")}</div>
            <button className='valid' onClick={(e) => submit(e)}>
                {t("button.valid")}
            </button>
            */}
            <div className='ending'>
                <h1 className='title'>{t("ending.title")}</h1>
                <p className='message'>{t("ending.message")}</p>
                <p className='footer'>{t("ending.footer")}</p>
            </div>
            <div className='socialLinks'>
                <div className='message'>
                    {/*
                    Each channel subscription entitles you to 1 ticket for the prize pool.
                    <br/>
                    The list of all social channels you can follow Noracle on:
                    */}
                    {t("content.follow")}
                </div>
                <div>
                    <a href='https://twitter.com/Noracleio' target="_blank" rel='noreferrer'></a>
                    <a href='https://t.me/noracleio' target="_blank" rel='noreferrer'></a>
                    <a href='https://discordapp.com/users/noracle' target="_blank" rel='noreferrer'></a>
                    <a href='https://medium.com/@media.noracle' target="_blank" rel='noreferrer'></a>
                    <a href='https://www.facebook.com/people/Noracle/100090735297322' target="_blank" rel='noreferrer'></a>
                    <a href='https://www.youtube.com/@noracle-io' target="_blank" rel='noreferrer'></a>
                    <a href='https://www.tiktok.com/@noracleio' target="_blank" rel='noreferrer'></a>
                </div>
            </div>
        </div>
    )
}